// project import
import pages from './pages';
import dashboard from './dashboard';
// import support from './support';

const menuItems = {
    items: [dashboard, pages]
};

export default menuItems;
